
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"8","viewBox":"1 0 8 8","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.606.513H4.398c-.344 0-.68.11-.958.312l-.977.71a1.63 1.63 0 00-.592.815l-.373 1.148a1.63 1.63 0 000 1.008l.373 1.148c.106.328.313.613.592.816l.977.71c.278.202.614.31.958.31h1.208c.344 0 .68-.108.958-.31l.977-.71a1.63 1.63 0 00.592-.816l.374-1.148a1.63 1.63 0 000-1.008L8.133 2.35a1.63 1.63 0 00-.592-.815l-.977-.71a1.63 1.63 0 00-.958-.312z","fill":"#F9B621","stroke":"#363636","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.276 3.085a.046.046 0 11-.046-.046M3.931 4.619a.046.046 0 11-.046-.047M6.076 4.885a.046.046 0 11-.046-.046","stroke":"#2B2B2B","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    